/**
 * Created by Claude on 25.02.2026
 */

const GeneratorMultiplierTutorial = function () {
    return new TutorialScenario(GeneratorMultiplierTutorial.NAME, {
        listSteps: function () {
            return [
                GeneratorMultiplierTutorial.createIconStep(),
                GeneratorMultiplierTutorial.createButtonStep(),
                GeneratorMultiplierTutorial.createExplainStep("GeneratorMultiplierTutorial.step3"),
                GeneratorMultiplierTutorial.createExplainStep("GeneratorMultiplierTutorial.step4")
            ];
        },

        isAvailable: function () {
            const generatorMultiplier = Merge2.current && Merge2.current.generatorMultiplier;
            return generatorMultiplier && generatorMultiplier.onGetView()
                && !cleverapps.forces.isShown(Forces.GENERATOR_MULTIPLIER) && Merge2.current.mode === Merge2.MODE_GAME;
        }
    });
};

GeneratorMultiplierTutorial.createIconStep = function () {
    return new TutorialStep({
        onStart: function () {
            const generatorMultiplier = Merge2.current.generatorMultiplier;
            Merge2TutorialHelper.scrollToExtraBarRow(Merge2.current.generatorMultiplier.index, () => {
                const force = Forces.GENERATOR_MULTIPLIER;
                force.gravitate = MinimalDialogue.GRAVITATE.BOTTOM;
                this.force = cleverapps.forces.create(generatorMultiplier.onGetView(), force);
            });

            cleverapps.tutorial.on("generator_multiplier_icon_clicked", () => {
                this.force && this.force.hideForceHints();
            }, this);
            cleverapps.tutorial.on("window_shown", this.finish.bind(this), this);
        },

        onFinish: function () {
            this.force && this.force.hideForceHints();
            Merge2.current.counter.trigger();
        }
    });
};

GeneratorMultiplierTutorial.createButtonStep = function () {
    return new TutorialStep({
        onStart: function () {
            const currentWindow = cleverapps.focusManager.currentWindow();

            this.force = cleverapps.forces.create(
                currentWindow.button, 
                {
                    finger: true,
                    text: "GeneratorMultiplierTutorial.step2",
                    gravitate: MinimalDialogue.GRAVITATE.BOTTOM,
                    position: function () {
                        return MinimalDialogue.POSITIONS.CENTER;
                    }
                },
                {
                    highlights: [currentWindow]
                }
            );

            cleverapps.tutorial.on("generator_multiplier_button_clicked", this.finish.bind(this), this);
        },

        onFinish: function () {
            Merge2.current.counter.trigger();
        }
    });
};

GeneratorMultiplierTutorial.createExplainStep = function (text) {
    return new TutorialStep({
        onStart: function () {
            const currentWindow = cleverapps.focusManager.currentWindow();
            if (!currentWindow || currentWindow.closed) {
                this.finish();
                return;
            }

            this.force = cleverapps.forces.create(ForceView.NO_ELEMENT, {
                text,
                position: function () {
                    return MinimalDialogue.POSITIONS.CENTER;
                },
                okButton: true
            }, {
                highlights: [currentWindow.wrapper]
            });

            cleverapps.tutorial.on("touchInShadow", this.finish.bind(this), this);
        },

        onFinish: function () {
            const currentWindow = cleverapps.focusManager.currentWindow();
            if (currentWindow) {
                currentWindow.focusState.eventNodes.push(currentWindow);
            }
            Merge2.current.counter.trigger();
        }
    });
};

GeneratorMultiplierTutorial.NAME = "generator_multiplier_tutorial";